<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>

        <img id="logo_img" :src="require('../assets/logo_bluchip.png')" style="display:none"/>

        <v-toolbar class="elevation-1">
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <template>
                <v-btn
                        color="primary"
                        class="ma-0"
                        min-width="0"
                        to="/invoices/create"
                >
                    <v-icon>add</v-icon>
                </v-btn>

            </template>
        </v-toolbar>

        <FormCard :title="$t('general.search_form')">
            <template v-slot:form>
                <v-form autocomplete="off">
                    <v-row dense>
                        <!-- Date pickers -->
                        <v-col cols="12" sm="4" md="4" lg="2">
                            <!-- Start date input -->
                            <v-menu v-model="start_time_picker"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field class="custom_textfield"
                                                  v-model="computedStartDateFormatted"
                                                  :label="$t('general.from')"
                                                  append-icon="event"
                                                  readonly
                                                  v-on="on"
                                                  outlined
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="search_options.start_time"
                                               @input="start_time_picker = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="2">
                            <!-- End date input-->
                            <v-menu v-model="end_time_picker"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field class="custom_textfield"
                                                  v-model="computedEndDateFormatted"
                                                  :label="$t('general.to')"
                                                  append-icon="event"
                                                  readonly
                                                  v-on="on"
                                                  outlined
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="search_options.end_time"
                                               @input="end_time_picker = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="2">
                            <v-select class="custom_textfield"
                                      :label="$t('general.client')"
                                      type="select"
                                      :items="clients"
                                      v-model="search_options.client_id"
                                      item-text="name"
                                      item-value="id"
                                      outlined
                                      @change="getSelectFieldProjects($event)"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="2">
                            <v-text-field
                                    class="custom_textfield"
                                    v-model="search_options.number"
                                    :label="$t('invoices.number')"
                                    outlined
                                    type="number"
                                    min="0"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <!-- Refresh button -->
                        <v-col cols="12">
                            <v-spacer></v-spacer>
                            <v-btn color="primary"
                                   @click="resetForm"
                            >
                                {{$t('general.reset_form')}}
                                <v-icon right>refresh</v-icon>

                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
        </FormCard>

        <v-container fluid>
            <ResponsiveDataTable :loading="dTableLoading"
                                 :headers="dTableHeaders"
                                 :items="dTableData"
                                 :enableSearch="false"
                                 :totalItems="dTableTotalItems"
                                 :mobileBreakpoint="960"
                                 :itemsPerPageOptions="[20,50,100,-1]"
                                 sortByColumn="3"
                                 :isDescending="true"
                                 :selectedItems="selected_items"
                                 :showSelect="false"
                                 @options-changed="optionsChanged"
            >
                <!-- Set actions -->
                <template v-slot:actions="slotProps">
                    <v-icon v-if="update_permission && !slotProps.item.is_cancelled && isLastInvoice(slotProps.item)"
                            class="material-icons"
                            color="primary"
                            @click="editItemTrigger(slotProps.item)"
                    > edit
                    </v-icon>
                    <v-icon v-if="repeat_permission && !slotProps.item.is_cancelled"
                            class="material-icons"
                            color="primary"
                            @click="repeatItemTrigger(slotProps.item)"
                    > repeat
                    </v-icon>
                    <v-icon v-if="cancel_permission"
                            class="material-icons"
                            :color="slotProps.item.is_cancelled ? 'error' : 'primary'"
                            @click="cancelItemTrigger(slotProps.item)"
                    > cancel
                    </v-icon>
                    <v-icon v-if="delete_permission && !slotProps.item.is_cancelled && isLastInvoice(slotProps.item)"
                            class="material-icons"
                            color="error"
                            @click="deleteItemTrigger(slotProps.item)"
                    > delete
                    </v-icon>
                    <v-icon class="material-icons"
                            color="primary"
                            @click="printItem(slotProps.item)"
                    > print
                    </v-icon>
                </template>
            </ResponsiveDataTable>
        </v-container>

        <!-- Confirm action dialog -->
        <ConfirmActionDialog :dialog="confirmDialog"
                             :header="confirmDialogHeader"
                             :message="confirmDialogMessage"
                             :color="confirmDialogColor"
                             :styleClass="confirmDialogClass"
                             :action="confirm_action"
                             @close="closeConfirmDialog"
                             @delete="deleteItemConfirmed"
                             @cancel="cancelItemConfirmed"
        ></ConfirmActionDialog>
    </div>
</template>

<script>
    import FormCard from '../components/FormCard.vue'
    import ResponsiveDataTable from '../components/ResponsiveDataTable.vue'
    import ConfirmActionDialog from '../components/ConfirmActionDialog.vue'

    let pdfMake = require('pdfmake/build/pdfmake.min.js');
    let pdfFonts = require('pdfmake/build/vfs_fonts.js');
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    pdfMake.tableLayouts = {
        footerTableLayout: {
            hLineWidth: function (i, node) {
                return i === 1 ? 1 : 0
            },
            vLineWidth: function (i, node) {
                return 0
            },
            hLineColor: function (i, node) {
                return '#c6c9cc';
            }
        },
        defaultTableLayout: {
            hLineWidth: function (i, node) {
                return 1;
            },
            vLineWidth: function (i, node) {
                return 1;
            },
            hLineColor: function (i, node) {
                return '#c6c9cc';
            },
            vLineColor: function (i, node) {
                return '#c6c9cc';
            }
        },
        panelTableLayout: {
            hLineWidth: function (i, node) {
                return 1;
            },
            vLineWidth: function (i, node) {
                return 1;
            },
            hLineColor: function (i, node) {
                return (i === 0 || i === node.table.body.length) ? '#c6c9cc' : 'white';
            },
            vLineColor: function (i, node) {
                return (i === 0 || i === node.table.widths.length) ? '#c6c9cc' : 'white';
            }
        }
    };

    export default {
        components: {
            FormCard,
            ResponsiveDataTable,
            ConfirmActionDialog
        },
        props: {
            title: {
                type: String
            }
        },
        computed: {
            computedStartDateFormatted() {
                return this.search_options.start_time ? this.moment(this.search_options.start_time).format('DD/MM/YYYY') : ''
            },
            computedEndDateFormatted() {
                return this.search_options.end_time ? this.moment(this.search_options.end_time).format('DD/MM/YYYY') : ''
            }
        },
        data() {
            return {
                url: '/api/invoices',
                current_user: this.$store.state.user,

                // Search form
                clients: [],
                settings: [],
                doys: [],
                vats: [],
                search_options: {
                    start_time: this.moment().startOf('month').format('YYYY-MM-DD'),
                    end_time: this.moment().format('YYYY-MM-DD'),
                    client_id: null,
                    number: null
                },
                search_criteria: {},
                start_time_picker: false,
                end_time_picker: false,

                // Data table
                dTableLoading: false,
                dTableHeaders: [
                    {
                        text: `${this.$t('invoices.number')}`,
                        value: 'number',
                        sortable: false,
                    },
                    {
                        text: `${this.$t('general.company')}`,
                        value: 'company_name',
                        sortable: false,
                    },
                    {
                        text: `${this.$t('general.client')}`,
                        value: 'client_name',
                        sortable: false,
                    },
                    {
                        text: `${this.$t('general.date')}`,
                        value: 'date',
                        sortable: true,
                    },
                    {
                        text: `${this.$t('general.total_price')}`,
                        value: 'total_price',
                        sortable: false,
                    },
                    {
                        text: `${this.$t('general.actions')}`,
                        value: 'actions',
                        align: 'right',
                        class: 'actions_header',
                        sortable: false,
                    },

                ],
                dTableData: [],
                dTableTotalItems: 0,
                dTableOptions: {
                    page: null,
                    itemsPerPage: null,
                    sortBy: [],
                    sortDesc: [],
                    groupBy: [],
                    groupDesc: [],
                    multiSort: false,
                    mustSort: false
                },
                work_hours_sum: 0,
                selected_items: [],

                // Confirmation dialog
                current_item_id: null,
                confirm_action: null,
                confirmDialog: false,
                confirmDialogColor: null,
                confirmDialogHeader: null,
                confirmDialogMessage: null,
                confirmDialogClass: null,

                // Permissions
                update_permission: false,
                repeat_permission: false,
                cancel_permission: false,
                delete_permission: false
            }
        },
        async mounted() {
            // Get permissions
            this.update_permission = await this.$store.dispatch('userHasPermission', 'update_invoices');
            this.repeat_permission = await this.$store.dispatch('userHasPermission', 'repeat_invoices');
            this.cancel_permission = await this.$store.dispatch('userHasPermission', 'cancel_invoices');
            this.delete_permission = await this.$store.dispatch('userHasPermission', 'delete_invoices');

            this.clients = (await this.$store.dispatch('fetchData', {url: '/api/clients/all'}))[0];
            this.settings = (await this.$store.dispatch('fetchData', {url: '/api/app-settings'})).data;

            this.$store.dispatch('fetchData', {url: '/api/doys'})
                .then(response => this.doys = response[0]);
            this.$store.dispatch('fetchData', {url: '/api/bank-accounts/all', params: {conditions: {is_active: 1}}})
                .then(response => this.bank_accounts = response[0]);
            this.$store.dispatch('fetchData', {url: '/api/vats/all'})
                .then(response => this.vats = response[0]);
        },
        watch: {
            search_options: {
                deep: true,
                async handler(val) {
                    const temp = Object.assign({}, val);

                    // Reset search criteria
                    this.search_criteria = {};

                    for (let key in temp) {
                        if (temp[key] && key !== 'start_time' && key !== 'end_time') {
                            this.search_criteria[key] = temp[key];
                        }
                    }

                    this.fetchTableData();
                }
            }
        },
        methods: {
            // calculate if the invoice is the last invoice for company's country
            isLastInvoice(item) {
                return item.company.id === 1 ? this.settings.invoice_number_gr === item.number :
                    this.settings.invoice_number_cy === item.number;
            },
            // Request API for data table data
            async fetchTableData() {
                // clear selected items and work hours sum
                this.selected_items = [];
                this.work_hours_sum = 0;

                // Set date and time criteria
                this.search_criteria.start_time = this.search_options.start_time;
                this.search_criteria.end_time = this.search_options.end_time;

                let response = await this.$store.dispatch('fetchData', {
                    url: this.url, params: {
                        search_options: this.search_criteria,
                        table_options: this.dTableOptions,
                    }
                });

                if (response) {
                    response.data.forEach(item => item.date = this.moment(item.date, 'YYYY-MM-DD').format('DD/MM/YYYY'));
                    this.dTableData = response.data;
                    this.dTableTotalItems = response.total;
                    this.dTableLoading = false;
                }
            },
            // If data table options have been changed request API for fresh data
            optionsChanged(options) {
                let options_changed = false;
                this.dTableLoading = true;

                // Check if options changed
                for (let prop in this.dTableOptions) {
                    if (this.dTableOptions[prop] !== options[prop]) {
                        options_changed = true;
                        break;
                    }
                }

                if (options_changed) {
                    this.dTableOptions = Object.assign({}, options);
                    this.fetchTableData();
                }
            },

            /**
             * Datatable actions
             */

            // Trigger edit item action
            editItemTrigger(item) {
                this.$router.push(`/invoices/edit/${item.id}`);
            },
            // Trigger repeat item action
            repeatItemTrigger(item) {
                this.$router.push(`/invoices/repeat/${item.id}`);
            },
            // Triggered when delete item button is pressed
            deleteItemTrigger(item) {
                this.confirmDialog = true;
                this.confirmDialogClass = 'fail';
                this.confirmDialogHeader = this.$t('invoices.deletion');
                this.confirmDialogMessage = this.$t('invoices.deletion_text');
                this.confirm_action = 'delete';
                this.current_item_id = item.id;
            },
            // Triggered when deletion of item is confirmed and requests API to actually delete it.
            async deleteItemConfirmed() {
                let response = await this.$store.dispatch('sendData', {
                    method: 'delete', url: `${this.url}/${this.current_item_id}`
                });

                if (response.status === 200) {
                    this.fetchTableData();
                }

                this.closeConfirmDialog();
            },
            // Triggered when delete item button is pressed
            cancelItemTrigger(item) {
                if (!item.is_cancelled) {
                    this.confirmDialog = true;
                    this.confirmDialogClass = 'fail';
                    this.confirmDialogHeader = this.$t('invoices.cancel');
                    this.confirmDialogMessage = this.$t('invoices.cancel_text');
                    this.confirm_action = 'cancel';
                    this.current_item_id = item.id;
                }
            },
            // Triggered when deletion of item is confirmed and requests API to actually delete it.
            async cancelItemConfirmed() {
                let response = await this.$store.dispatch('sendData', {
                    method: 'patch', url: `${this.url}/is-cancelled/${this.current_item_id}`
                });

                if (response.status === 200) {
                    this.fetchTableData();
                }

                this.closeConfirmDialog();
            },
            // Close action confirm dialog
            closeConfirmDialog() {
                this.confirmDialog = false;
                this.current_item_id = null;
            },

            /**
             * Print PDF
             */
            // create canvas for the given image id
            createImageCanvas(image_id) {
                let image = document.getElementById(image_id);
                let canvas = document.createElement('canvas');
                canvas.width = image.width;
                canvas.height = image.height;
                canvas.getContext('2d').drawImage(image, 0, 0);
                canvas.toDataURL('image/png');
                return canvas;
            },
            // get object with pdf styles
            pdfStyles() {
                return {
                    header_text: {
                        fontSize: 10,
                        bold: true,
                        alignment: 'right',
                        color: '#0079c2'
                    },
                    field_left: {
                        bold: true
                    },
//                    code: {
//                        fontSize: 12,
//                        bold: true,
//                    },
//                    header: {
//                        bold: true,
//                        alignment: 'center'
//                    },
//                    'html-p': {
//                        fontSize: 12,
//                    },
//                    'ql-align-center': {
//                        alignment: 'center'
//                    },
//
//                    footer: {
//                        background: '#ff0000',
//                        border: '1px'
//                    },
                };
            },
            // create divider header
            createHeaderLine(text, font_size = 12) {
                return {
                    table: {
                        widths: ['100%'],
                        headerRows: 1,
                        body: [[{
                            text: text, style: 'header', fontSize: font_size, alignment: 'center', bold: true
                        }], ['']]
                    },
                    layout: 'footerTableLayout',
                    margin: [0, 0, 0, 5]
                }
            },
            // get pdf header object
            pdfHeader(company) {
                let logo_canvas = this.createImageCanvas('logo_img');

                return {
                    alignment: 'justify',
                    columns: [
                        {image: logo_canvas.toDataURL('image/png'), width: 150, margin: [0, 2, 0, 0]},
                        {
                            width: '*',
                            text: this.$tc('general.invoice_title', parseInt(company.country_id)).toUpperCase(),
                            style: 'header_text', margin: [0, 23, 0, 0]
                        },
                    ],
                    margin: [40, 40, 40, 0],
                    style: {fillColor: 'black'}
                };
            },
            // get pdf footer object
            pdfFooter(bank_account_id) {
                let bank_account = this.bank_accounts.find(obj => obj.id === bank_account_id);

                return {
                    style: 'footer',
                    layout: 'footerTableLayout',
                    table: {
                        widths: ['100%'],
                        headerRows: 1,
                        body: [
                            [{
                                text: this.$t('bank_accounts.details'), bold: true, margin: [0, 0, 0, 10]
                            }],
                            [{
                                text: `${bank_account.name}, ${this.$t('general.swift')}: ${bank_account.swift}`,
                                bold: true, margin: [0, 10, 0, 0]
                            }],
                            [{
                                text: `${bank_account.address}`, bold: true
                            }],
                            [{
                                text: `${this.$t('general.iban').toUpperCase()} : ${bank_account.iban}`,
                                bold: true, margin: [0, 0, 0, 0]
                            }]
                        ]
                    },
                    margin: [40, 0, 40, 0]
                }
            },

            // get object with invoice's company details
            pdfCompanyDetails(item) {

                let client_doy = this.doys.find(obj => obj.id === item.client.doy);
                let country_id = parseInt(item.company.country_id);
                let details_fourth_row_text = '';

                // Greek company
                if (country_id === 1) {
                    let company_doy = this.doys.find(obj => obj.id === item.company.doy_id);
                    details_fourth_row_text = company_doy ? company_doy.name : '';
                } else {
                    details_fourth_row_text = item.company.registration_number ? item.company.registration_number : '';
                }

                let body = [
                    [
                        {text: item.company.name},
                        {
                            columns: [
                                {width: '*', text: `${this.$t('forms.vat')} :`, style: 'field_left'},
                                {width: 61, text: item.company.vat}
                            ],
                            alignment: 'right'
                        }
                    ],
                    [
                        {text: item.company.address},
                        {
                            columns: [
                                {width: '*', text: `${this.$t('general.date')} :`, style: 'field_left'},
                                {width: 64, text: item.date}
                            ],
                            alignment: 'right'
                        }
                    ],
                    [
                        {
                            columns: [
                                {
                                    width: country_id === 1 ? 37 : 82,
                                    text: `${country_id === 1 ? this.$t('forms.doy') : this.$t('general.register_number')} :`,
                                    style: 'field_left'
                                },
                                {width: '*', text: details_fourth_row_text}
                            ]
                        },
                        {
                            columns: [
                                {
                                    width: '*', text: `${this.$tc('general.invoice_number_short', country_id)} :`,
                                    style: 'field_left'
                                },
                                {
                                    width: country_id === 1 ? 20 : 48,
                                    text: country_id === 1 ? item.number : `${item.number}/${this.moment(item.created_at).format('YYYY')}`
                                }
                            ],
                            alignment: 'right'
                        }
                    ]
                ];

                return {
                    table: {
                        widths: ['50%', '50%'],
                        body: body
                    },
                    layout: 'noBorders',
                    margin:
                        [0, 0, 0, 5]
                };
            },
            // get object with invoice's company details
            pdfClientDetails(item) {

                let body = [
                    [
                        {
                            columns: [
                                {width: 48, text: this.$t('general.client'), style: 'field_left'},
                                {width: '*', text: ` :  ${item.client.name}`}
                            ]
                        },
                    ],
                ];

                if (item.client.vat) {
                    body.push([
                        {
                            columns: [
                                {width: 41, text: `${this.$t('forms.vat')} :`, style: 'field_left'},
                                {width: '*', text: item.client.vat}
                            ]
                        }
                    ])
                }

                if (item.client.doy) {
                    let found_doy = this.doys.find(obj => obj.id === item.client.doy);

                    if (found_doy) {
                        body.push([
                            {
                                columns: [
                                    {width: 37, text: `${this.$t('forms.doy')} :`, style: 'field_left'},
                                    {width: '*', text: found_doy.name}
                                ]
                            }
                        ]);
                    }
                }

                if (item.client.street || item.client.street_no || item.client.city) {

                    let address = `${item.client.street ? item.client.street : ''} ${item.client.street_no ? item.client.street_no : ''}`;

                    if (item.client.city) {
                        address += `${address ? ', ' : ''} ${item.client.city}`;
                    }

                    body.push([
                        {
                            columns: [
                                {width: 65, text: `${this.$t('general.address')} :`, style: 'field_left'},
                                {width: '*', text: address}
                            ]
                        }
                    ]);
                }

                return {
                    table: {
                        widths: ['100%'],
                        body: body
                    },
                    layout: 'noBorders',
                    margin:
                        [0, 0, 0, 10]
                };
            },
            // get object with invoice's services
            pdfServicesDetails(services) {
                let body = [
                    [
                        {text: this.$t('general.description'), bold: true},
                        {text: this.$t('general.price'), alignment: 'right', bold: true}
                    ]
                ];

                services.forEach(obj => {
                    body.push([
                        {text: obj.description},
                        {text: obj.price, alignment: 'right'}
                    ])
                });

                return {
                    table: {
                        widths: ['*', 60],
                        body: body
                    },
                    layout: 'defaultTableLayout',
                    margin: [0, 0, 0, -1]
                }
            },
            // get object with invoice's charges
            pdfChargesDetails(item) {
                let found_vat = this.vats.find(obj => obj.id === item.vat);
                let country_id = parseInt(item.company.country_id);

                return {
                    table: {
                        widths: ['*', 120, 60],
                        body: [
                            [
                                {
                                    border: [country_id === 2, country_id === 2, country_id === 2, country_id === 2],
                                    text: country_id === 2 ? this.$t('general.invoice_cy_text') : '',
                                    rowSpan: 3,
                                    fontSize: 9,
                                    alignment: 'justify',
                                    margin: [0, 20, 0, 0]
                                },
                                {text: this.$t('invoices.services_price')},
                                {text: item.services_price, alignment: 'right'}
                            ],
                            [
                                '',
                                {text: `${this.$t('general.vat')} %`},
                                {text: found_vat.value, alignment: 'right'}
                            ],
                            [
                                '',
                                {text: this.$t('general.total_price')},
                                {text: item.total_price, alignment: 'right'}
                            ]
                        ],
                    },
                    layout: 'defaultTableLayout'
                }

            },
            // Trigger print item action
            printItem(item) {

                let pdf_document = {
                    info: {title: `invoice_${item.number}`, download: `invoice_${item.number}.pdf`},
                };

                // add watermark in cancelled invoice
                if (item.is_cancelled) {
                    pdf_document.watermark = {text: 'ΑΚΥΡΟ', color: 'red', opacity: 0.6, bold: true, italics: false};
                }

                pdf_document.pageMargins = [40, 81, 40, 132];
                pdf_document.header = this.pdfHeader(item.company);
                pdf_document.styles = this.pdfStyles();
                pdf_document.defaultStyle = {columnGap: 5};
                pdf_document.footer = this.pdfFooter(item.bank_account_id);

                pdf_document.content = [
                    this.createHeaderLine(''),
                    this.pdfCompanyDetails(item),
                    this.createHeaderLine(''),
                    this.pdfClientDetails(item),
                    this.pdfServicesDetails(item.services),
                    this.pdfChargesDetails(item)
                ];

                pdfMake.createPdf(pdf_document).open();
            },

            /**
             * Search
             */

            // Reset the form data
            resetForm() {
                for (let prop in this.search_options) {
                    this.search_options[prop] = (prop === 'start_time') ? this.moment().startOf('month').format('YYYY-MM-DD')
                        : (prop === 'end_time') ? this.moment().format('YYYY-MM-DD') : null;
                }
            }
        }
    }
    ;
</script>
